import { fetchQuery } from "relay-runtime";
import environment from "environments/environment";
import getAppsQuery from "./queries/getApps";
import getGtmIdQuery from "./queries/getGtmId"
const getApps = (orgId, propertyId) => {
    let variables = { orgId, propertyId };
    return fetchQuery(environment, getAppsQuery, variables)
        .then(res => {
            return res;
        })
        .catch(err => {
            return { errors: [{ message: err.toString() }] };
        });
};


const getGtmId = (propertyId) => {
    const variables = { propertyId };
    return fetchQuery(environment, getGtmIdQuery, variables)
        .then(res => {
            return res;
        })
        .catch(err => {
            return { errors: [{ message: err.toString() }] };
        });
}

export {
    getApps,
    getGtmId,
};
